import script from "./AddFileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddFileModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddFileModal.vue?vue&type=style&index=0&id=6f24aa05&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f24aa05"]])

export default __exports__